import React__default from 'react';
import { Headline } from '../headline/headline.esm.js';

/**
 * @description
 * **An atomic component that accepts an element as children and applies styles to
 * function as a fullwidth primary-color heading**
 *
 * @property {React.ReactNode} **children**: Nested element between CategoryBar
 * tags provided by consumer to serve as the category title
 *
 * @example
 * <CategoryBar><Link href={categoryLinkUrl}>{categoryTitle}</Link></CategoryBar>
 *
 * <CategoryBar>
 *    <a href={"/news/category/2134"}>
 *      Mock Category Title
 *    </a>
 * </CategoryBar>
 */
var CategoryBar = function CategoryBar(_ref) {
  var children = _ref.children,
    _ref$headlineTag = _ref.headlineTag,
    headlineTag = _ref$headlineTag === void 0 ? 'h2' : _ref$headlineTag;
  return children ? /*#__PURE__*/React__default.createElement(Headline, {
    as: headlineTag,
    className: "w-full font-sans text-p-12 text-action-primary hover:underline"
  }, /*#__PURE__*/React__default.createElement("span", null, children)) : null;
};

export { CategoryBar };
//# sourceMappingURL=category-bar.esm.js.map
